module.exports = __webpack_public_path__ + "static/media/creamPants.a47fbf2f.jpg";